import React from "react"

const Footer = () => {
    const date = new Date();
    const currentYear = date.getFullYear();
    
    return (
        <section className="footer">
            <h6 className="fw-400 m-0">Copyright © {currentYear} by Notenetic</h6>
        </section>
    )
}

export default Footer